import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethree-courses',
  templateUrl: './homethree-courses.component.html',
  styleUrls: ['./homethree-courses.component.scss']
})
export class HomethreeCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
